export default __webpack_public_path__ + "./fonts/WF-006389-009281-000054.woff";